// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 20,
  argument: "",
  verses: [
    { n: 1, text: "Wine is a luxurious thing, and drunkenness riotous: whosoever is delighted therewith, shall not be wise." },
    { n: 2, text: "As the roaring of a lion, so also is the dread of a king: he that provoketh him, sinneth against his own soul." },
    { n: 3, text: "It is an honour for a man, to separate himself from quarrels: but all fools are meddling with reproaches." },
    { n: 4, text: "Because of the cold the sluggard would not plough: he shall beg therefore in the summer, and it shall not be given him." },
    { n: 5, text: "Counsel in the heart of a man is like deep water: but a wise man will draw it out." },
    { n: 6, text: "Many men are called merciful: but who shall find a faithful man?" },
    { n: 7, text: "The just that walketh in his simplicity, shall leave behind him blessed children." },
    { n: 8, text: "The king, that sitteth on the throne of judgment, scattereth away all evil with his look." },
    { n: 9, text: "Who can say: My heart is clean, I am pure from sin?" },
    { n: 10, text: "Diverse weights and diverse measures, both are abominable before God." },
    { n: 11, text: "By his inclinations a child is known, if his works be clean and right." },
    { n: 12, text: "The hearing ear, and the seeing eye, the Lord hath made them both." },
    { n: 13, text: "Love not sleep, lest poverty oppress thee: open thy eyes, and be filled with bread." },
    { n: 14, text: "It is naught, it is naught, saith every buyer: and when he is gone away, then he will boast." },
    { n: 15, text: "There is gold and a multitude of jewels: but the lips of knowledge are a precious vessel." },
    { n: 16, text: "Take away the garment of him that is surety for a stranger, and take a pledge from him for strangers." },
    { n: 17, text: "The bread of lying is sweet to a man: but afterwards his mouth shall be filled with gravel." },
    { n: 18, text: "Designs are strengthened by counsels: and wars are to be managed by governments." },
    { n: 19, text: "Meddle not with him that revealeth secrets, and walketh deceitfully, and openeth wide his lips." },
    { n: 20, text: "He that curseth his father, and mother, his lamp shall be put out in the midst of darkness." },
    { n: 21, text: "The inheritance gotten hastily in the beginning, in the end shall be without a blessing." },
    { n: 22, text: "Say not: I will return evil: wait for the Lord, and he will deliver thee." },
    { n: 23, text: "Diverse weights are an abomination before the Lord: a deceitful balance is not good." },
    { n: 24, text: "The steps of man are guided by the Lord: but who is the man that can understand his own way?" },
    { n: 25, text: "It is ruin to a man to devour holy ones, and after vows to retract." },
    { n: 26, text: "A wise king scattereth the wicked, and bringeth over them the wheel." },
    { n: 27, text: "The spirit of a man is the lamp of the Lord, which searcheth all the hidden things of the bowels." },
    { n: 28, text: "Mercy and truth preserve the king, and his throne is strengthened by clemency." },
    { n: 29, text: "The joy of young men, is their strength: and the dignity of old men, their grey hairs." },
    { n: 30, text: "The blueness of a wound shall wipe away evils: and stripes in the more inward parts of the belly." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "A luxurious thing. Hebrew, \"a scoffer.\" Chaldean, \"renders one a scoffer.\" — Drunkenness. Hebrew ssocor, any strong drink, particularly palm-wine. Intemperance places the strongest obstacles in the way of wisdom. It causes a person to mock at all sacred things, and to be quarrelsome, chap. xxiii. 29., and Ephesians v. 18.", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "Reproaches. It is better not to commence a lawsuit, even when we are in the right, chap. xvii. 11. (Calmet) — Plena victoria est ad clamantem tacere.", attribution: "Val. Max." }
    ] },
    { verse: 5, notes: [
      { text: "Out. So David discovered the meaning of the Thecuite, 2 Kings xiv. 18. A wise politician carefully examines everything in a foreign court.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Faithful. Few continue steady to their engagements or friends, whom they will assist to a certain point. In God these two virtues always go together, Psalm lxxxiv. 11. But they are rarely found in men.", attribution: "Calmet" }
    ] },
    { verse: 8, notes: [
      { text: "Look. It is the duty of kings to administer justice.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Sin. Protestants, \"my sin?\" We know not when it is remitted. (Haydock) — Without a special revelation, no one can be secure, 1 John i. 8., and Ecclesiastes ix. 1. (Bayn.)", attribution: "St. Augustine in Psalm cxlix." }
    ] },
    { verse: 10, notes: [
      { text: "Measures. In commerce, (Calmet) as well as in judging.", attribution: "St. Gregory in Ezechiel iv." }
    ] },
    { verse: 11, notes: [
      { text: "Right. We may form some judgment of his future conduct, from the inclinations which he manifests in his infancy. Naturam expellas furca, tamen ipsa recurret, Et mala perrumpet furtim fastidia victrix.", attribution: "Horace" }
    ] },
    { verse: 12, notes: [
      { text: "Both. Consequently he will know all our actions, Psalm xciii. 9. We must refer all to him, as he gives us the means of learning.", attribution: "Calmet" }
    ] },
    { verse: 13, notes: [
      { text: "Sleep. Septuagint, \"back-biting, that thou mayst not be taken off.\"", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Buyer. This is the common practice; yet it is not without exceptions. St. Augustine (Trin. xiii. 3.) observes, that the mountebank having promised to tell what every person had in his heart, many came to the theatre, when he told them that they all wished to buy cheap, and to sell dear. They all applauded the remark. (Calmet) — Septuagint is here defective.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Strangers. For whom he has bound himself foolishly, chap. vi. 1. All who have the care of others, must answer for them.", attribution: "Calmet" }
    ] },
    { verse: 17, notes: [
      { text: "Lying. Deceit, and unlawful pleasures, chap. ix. 17. But God mingles disgust with them, and will punish the guilty, at least hereafter. Worldly enjoyments seem sweet, but they are full of gravel, and hurtful.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "Governments. Or prudence, else the best designs may prove abortive.", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "Lips. And speaketh much. These people are unworthy of our friendship.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Lamp. Prosperity, or children.", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "Blessing. It is morally impossible that they should have been acquired justly, chap. xiii. 11., and xxi. 5.", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: "Evil. And revenge myself. This belongs to the Lord, Deuteronomy xxxii. 35. Man would be too favourable to himself, and would also pronounce his own condemnation, as he is also a sinner.", attribution: "Haydock" }
    ] },
    { verse: 24, notes: [
      { text: "Way? Jeremias x. 23. Independently of God, who can do any good?", attribution: "Calmet" }
    ] },
    { verse: 25, notes: [
      { text: "Ones. Hebrew, \"the saint or holy thing.\" (Haydock) — Chaldean, \"to make a vow for the sanctuary, and afterwards repent;\" having acted inconsiderately at first. To attack the persons or relics of the saints, or to plunder what is consecrated to pious uses, will bring on destruction; so also to make vows, and then seek to evade them, will not pass unpunished.", attribution: "Calmet" }
    ] },
    { verse: 26, notes: [
      { text: "Wheel. Or triumphal arch, fornicem. (Ven. Bede; Jansenius) — He will make his enemies lie prostrate under his chariot-wheels, 2 Kings xii. 31.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Lamp. The breath of life, (Genesis ii. 7.) and the light of man, 1 Corinthians ii. 11.", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Clemency. Such a king need not fear rebellion.", attribution: "Calmet" }
    ] },
    { verse: 29, notes: [
      { text: "Hairs, and experience. They have a greater contempt of death and pleasures.", attribution: "St. Ambrose, Hex. i. 8." }
    ] },
    { verse: 30, notes: [
      { text: "Evils. The wicked shall derive benefit from correction. — Belly. They shall feel the remorse of conscience, as Chaldean seems to indicate. (Calmet) — A serious illness often causes people to repent.", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
